// @flow

import { type IncomingPayment } from './types';

export function isPaymentArcus(incomingPayment: IncomingPayment): boolean {
  const speiBankInfo = incomingPayment['spei_bank_info'];
  if (!speiBankInfo || speiBankInfo != 'spei-arcus'){
    return false;
  }
  return true;
}
